import { Component, ViewChild } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from "@angular/material";
import { FormControl } from "@angular/forms";
import { environment } from "environments/environment";

@Component({
  selector: "app-accial",
  templateUrl: "./accial.component.html",
  styleUrls: ["./accial.component.scss"],
})
export class AccialComponent {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  pageSizeOptsAccial = [15, 20, 30, 50, 100, 200];
  displColsAccial = [
    "RUCProv",
    "FEmisionContrato",
    "MontoAdelanto",
    "PlazoContrato",
    "CodValorFN",
    "MontoDes",
    "Moneda",
    "FDesContrato",
    "FDesReal",
    "TEA",
    "Estado",
    "NroFactura",
  ];
  facturasAccial: any = [];
  dSourceAccial: any;
  loading: boolean;

  rucProv = new FormControl();
  rucAdq = new FormControl();
  rSocialAdq = new FormControl();

  constructor() {
    this.obtenerFacturasAccial();
  }

  obtenerFacturasAccial() {
    this.loading = true;
    setTimeout(() => {
      this.facturasAccial = [{}, {}, {}, {}, {}];
      this.dSourceAccial = new MatTableDataSource(this.facturasAccial);
      this.dSourceAccial.sort = this.sort;
      this.dSourceAccial.paginator = this.paginator;
      this.loading = false;
    }, 2000);
  }

  filtradoAccial() {
    alert('Me invocaron para aplicar los filtros y buscar.');
  }

}
